import React, {
    createContext,
    ReactNode,
    useCallback,
    useContext,
    useEffect,
    useState
} from 'react';
import {useGroupContext} from "./group_context";

export interface NotificationProviderContextType {
    currentNotifications: string[];
    jobsOpen: boolean;
    setJobsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    openJobsPopup: () => void;
}

export const NotificationProviderContext = createContext<NotificationProviderContextType | undefined>(undefined);

interface NotificationProviderProps {
    children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
                                                                              children,
                                                                          }) => {
    const {
        currentGroup,
    } = useGroupContext()!;

    const [currentNotifications, setCurrentNotifications] = useState<string[]>([]);
    const [jobsOpen, setJobsOpen] = useState(false);

    useEffect(() => {
        if (!currentGroup) {
            setCurrentNotifications(() => ["Please select a group to view notifications"]);
        } else {
            setCurrentNotifications([])
        }
    }, [currentGroup]);

    const openJobsPopup = useCallback(() => {
        setJobsOpen(true);
    }, []);

    const contextValue: NotificationProviderContextType = {
        currentNotifications,
        jobsOpen,
        setJobsOpen,
        openJobsPopup,
    };

    return (
        <NotificationProviderContext.Provider value={contextValue}>
            {children}
        </NotificationProviderContext.Provider>
    );
};

export const useNotificationContext = () => useContext(NotificationProviderContext);
